import axios from 'axios';

export default {
  namespaced: true,
  state: {
    integrations: {},
    error: "",
    loaded: false,
  },
  mutations: {
    setIntegrations(state, integrations) {
      state.integrations = integrations;
      state.loaded = true;
    },
    setError(state, error) {
      state.error = error;
      state.loaded = false;
    },
  },
  actions: {
    async getIntegrations({ commit }) {
      try {
        const res = await axios.get(`${process.env.VUE_APP_INTEGRATIONS}/integrations`);
        commit('setIntegrations', res.data.integrations);
      } catch (error) {
        commit('setError', error)
      }
    }
  }
};
